<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
  <b-modal
    :id="id"
    modal-class="giga-modal"
    dialog-class="modal-lg"
    content-class="text-center pb-2"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    lazy
  >
    <div class="gigawhat-modal">
      <div class="modal-heading">
        <h2 class="modal-title" v-text="title"></h2>
        <p class="modal-description" v-text="description"></p>
      </div>

      <ul class="gigwhat-navTabs">
        <li
          class="navTab_item"
          :class="[
            { 'active-navTab': currentTab == tab.id },
            { 'done-stepTab': tab.id < currentTab }
          ]"
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <button @click="tabNavigation(tab.id)">
            <span v-if="tab.id < currentTab" class="navTab-item_done">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.782"
                height="7.769"
                viewBox="0 0 10.782 7.769"
              >
                <path
                  id="Tracé_2381"
                  data-name="Tracé 2381"
                  d="M67.246,104.023a1.113,1.113,0,0,0,.79-.327l5.534-5.534a1.117,1.117,0,0,0-1.58-1.58l-4.744,4.744L65.023,99.1a1.117,1.117,0,1,0-1.58,1.58l3.013,3.013a1.114,1.114,0,0,0,.79.327Z"
                  transform="translate(-63.115 -96.254)"
                  fill="#808fa3"
                />
              </svg>
            </span>
            <span v-else class="navTab-item_number">{{ tab.id }}</span>
            {{ tab.label }}
          </button>
        </li>
      </ul>

      <Transition name="fade">
        <user-steper
          :$v="$v"
          :userForm="userForm"
          :currentTab="currentTab"
        ></user-steper>
      </Transition>

      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
              id="btn-precedent"
              v-if="currentTab > 1"
              class="giga-blue_outlined_button no-icon"
              @click="goBack()"
            >
              Précédent
            </button>
          </div>
          <div class="giga-button">
            <button
              id="btn-leave"
              v-if="currentTab == 1"
              class="giga-blue_outlined_button no-icon"
              @click="$emit('closeClick')"
            >
              Quitter
            </button>
          </div>
        </div>
        <div class="half-footer right-content">
          <div class="giga-button">
            <button
              id="btn-next"
              v-if="currentTab < tabs.length"
              :disabled="$v.userForm.$invalid"
              class="giga-green_button no-icon"
              @click="goNext()"
            >
              Suivant
            </button>
            <button
              id="btn-submit"
              v-if="currentTab == tabs.length"
              :disabled="$v.userForm.$invalid"
              class="giga-green_button no-icon"
              @click="saveUser()"
            >
              Terminer
            </button>
          </div>
        </div>
      </div>

      <!--      <form  action="">-->
      <!-- <div class="input-row">
        <label class="input-label">Votre Prénom</label>
        <div class="input-field">
          <input :disabled="isReadOnly" v-model="$v.userForm.firstName.$model" class="input-text" type="text" >
        </div>
        <div v-if="$v.userForm.firstName.$anyDirty && $v.userForm.firstName.$invalid">
          <small class="form-text text-danger" v-if="!$v.userForm.firstName.required">
            {{$t('required_field')}}
          </small>
        </div>
      </div> -->
      <!-- <div class="input-row">
        <label class="input-label">Votre Nom</label>
        <div class="input-field">
          <input :disabled="isReadOnly" v-model="$v.userForm.lastName.$model" class="input-text" type="text" >
        </div>
        <div v-if="$v.userForm.lastName.$anyDirty && $v.userForm.lastName.$invalid">
          <small class="form-text text-danger" v-if="!$v.userForm.lastName.required">
            {{$t('required_field')}}
          </small>
        </div>
      </div> -->
      <!-- <div class="input-row">
        <label class="input-label">Email</label>
        <div class="input-field">
          <input :disabled="isReadOnly" v-model="$v.userForm.email.$model" class="input-text" type="text" >
        </div>
        <div v-if="$v.userForm.email.$anyDirty && $v.userForm.email.$invalid">
          <small class="form-text text-danger" v-if="!$v.userForm.email.required">
            {{$t('required_field')}}
          </small>
        </div>
      </div>
      <div class="input-row">
      <b-form-checkbox
          id="admin"
          name="admin"
          v-model="$v.userForm.isAdmin.$model"
          class="custom-checkbox"
          :disabled="isReadOnly"
      >
        <div class="label-content">Administrateur</div>
      </b-form-checkbox>
      </div>

      <div class="input-row" v-if="!userForm.isAdmin">
        <label class="input-label">Role</label>
        <div class="input-field">
          <select v-model="$v.userForm.role.$model" :disabled="userForm.isAdmin || isReadOnly" class="input-select" name="" id="">
            <option v-for="(role,index) in roles" :key="index" :value="role">{{role.name}}</option>
          </select>
          <div v-if="$v.userForm.role.$anyDirty && $v.userForm.role.$invalid">
            <small class="form-text text-danger" v-if="!$v.userForm.role.required">
              {{$t('required_field')}}
            </small>
          </div>
        </div>
      </div> -->
      <!-- <div class="modal-footer"> -->
      <!-- <b-button :class="isReadOnly ? 'modal-submit_button' : 'modal-cancel_button'" type="button" @click="$emit('closeClick')">
          {{ isReadOnly ? 'Fermer' : 'Annuler' }}
        </b-button> -->
      <!--        <button v-if="isReadOnly" class="modal-submit_button" type="button" @click="$emit('closeClick')">Fermer</button>-->
      <!-- <b-button v-if="!isReadOnly"  class="modal-submit_button" type="submit" :disabled="$v.userForm.$invalid" @click="$emit('confirmClick')">Valider</b-button> -->
      <!-- </div> -->
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import UserSteper from "./UserStepper.vue";
import { constants } from "@/shared/constants";

export default {
  name: "UserModal",
  props: ["id", "title", "description", "userForm", "loader", "isReadOnly"],
  components: { UserSteper },
  userForm: {
    lastName: "",
    firstName: "",
    email: "",
    isEnabled: false,
    isAdmin: false,
    role: [],
    agence: {},
    agences: []
  },
  data() {
    return {
      tabs: [
        {
          id: 1,
          label: "Attribuer un rôle"
        },
        {
          id: 2,
          label: "Informations de l'utilisateur"
        }

        // {
        //   id: 3,
        //   label: "Attribuer les accès",
        // },
      ]
    };
  },
  validations() {
    return {
      userForm: {
        lastName: {
          required: requiredIf(() => {
            return this.currentTab === 2;
          })
        },
        firstName: {
          required: requiredIf(() => {
            return this.currentTab === 2;
          })
        },
        agence: {
          required: requiredIf(() => {
            return (
              this.currentUser.clientType == "B2B2B" &&
              this.currentTab === 2 &&
              this.userForm.role.roleType == "USER"
            );
          })
        },
        agences: {
          required: requiredIf(() => {
            return (
              this.currentUser.clientType === "B2B2B" &&
              this.currentTab === 2 &&
              this.userForm.role.roleType === "ADMIN_AGENCE"
            );
          })
        },
        role: {
          required
        },
        email: {
          required: requiredIf(() => {
            return this.currentTab === 2;
          }),
          email,
          emailForbiddenPattern: constants.emailForbiddenPattern
        },
        phoneNumber: {
          phone: constants.phonePattern
        }
      }
    };
  },
  computed: {
    ...mapGetters("user", { currentTab: "getCurrentTab" }),
    ...mapGetters("account", { currentUser: "getCurrentUser" })
  },
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      this.goTo(1);
      this.$v.$reset();
    });
  },
  methods: {
    ...mapMutations("user", { goTo: "goNext" }),
    goNext() {
      this.navigateTo(this.currentTab + 1);
    },
    goBack() {
      this.goTo(this.currentTab - 1);
    },
    tabNavigation(id) {
      let tab = this.tabs.findIndex(item => item.id == id);
      this.navigateTo(tab + 1);
    },

    navigateTo(id) {
      if (!this.$v.userForm.$invalid) {
        this.goTo(id);
      } else {
        this.$v.userForm.$anyDirty = true;
      }
    },

    saveUser() {
      this.userForm.isAdmin = this.userForm.role.id === 0;
      this.userForm.agence =
        this.userForm.role.id === 0 ? null : this.userForm.agence;
      this.$emit("confirmClick");
    }
  }
};
</script>

<style scoped></style>
